module.exports = __webpack_public_path__ + "static/flags/DR-5bbc6e1be2f89709babe7154416321fa.gif";